import React, { useState, useEffect } from "react";
import { Row, Col, Container, Modal } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import demofile from './../assets/images/demofile.png'
import Navigation from "../components/Navigation";
import DragAndDrop from "../components/home/DragAndDrop";
import FeatureCard from "../components/home/FeatureCard";
import FeatureContent from "../components/home/FeaturesContent";
import Footer from "../components/Footer";
import { featureCardContent } from "../utils/data";
import { featureContent } from "../utils/data";
import logo from '../assets/icons/Group 7 (1).png';
import "../css/home.css";
import instance from "../services/instance";
import Api from "../services/Api";
import { getbase64 } from "../services/hash";
import moment from "moment";

const Home = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  const [fileName, setFileName] = useState("");
  const [hashVal, setHash] = useState("");
  const [item, setItem] = useState("");
  const [loader, setloader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [text, settext] = useState("");
  const [msg, setmsg] = useState("Verifed Successfully");

  const onSubmit = async (fileName) => {
    try {
      setloader(true);
      let stringbase64 = await getbase64(fileName);
      var hashed;
      const crypto = require("crypto");
      const hash = crypto.createHash("sha256");
      hash.on("readable", () => {
        const data = hash.read();
        if (data) {
          hashed = data.toString("hex");
        }
      });
      hash.write(stringbase64); // data to be hashed string or base64 of file
      hash.end();

      instance.methods
        .certificate(hashed)
        .call()
        .then((itm) => {
          console.log(itm);

          setItem(itm);
          setloader(false);
          if (itm.hash == hashed) {
            callapi(hashed);
            settext(`
            This document was issued by ${itm.issuedBy} on ${moment
              .unix(itm.createdOn)
              .format("dddd, MMMM Do YYYY, h:mm:ss a")}`);
            setmsg("Verifed Successfully");
            setModalShow(true);
          } else {
            setmsg("Document Not Found");
            setModalShow(true);
            settext(
              "Invalid Document. Kindly contact us for more information."
            );
          }
        });
    } catch (err) {
      setloader(false);
      alert("Connect to Dapp compatible browser");
    }
  };

  const callapi = (id) => {
    Api.get(`/certificate?hash=${id}`)
      .then((response) => {
        setFileName(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <Navigation />

      <Container className="hero justify-content-md-center">
        <Modal
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <p className="hero-headline my-3">
              <span className="accent">Verification demo </span>
            </p>
          </Modal.Header>
          <Modal.Body className="justify-content-center text-left">
              <ul>
              <li>Download dummy file <a href={demofile} target="_blank" download>Click here </a></li>
              <li>To verify, directly upload or drag-and-drop the demo file on the portal</li>
            
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="mt-4 linear-btn"
              onClick={() => setModalShow2(false)}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <p className="hero-headline my-3">
              <span className="accent">{msg}</span>
            </p>
          </Modal.Header>
          <Modal.Body className="justify-content-center text-center">
            {text}
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            {msg == "Verifed Successfully" && (
              <a
                className="mt-4 linear-btn"
                href={
                  "https://rinkeby.etherscan.io/address/0x6c9799ABc234b607e26833c19Aa5bB14588663D2"
                }
                target="_blank"
              >
                View on blockchain
              </a>
            )}
            <button
              className="mt-4 linear-btn"
              onClick={() => setModalShow(false)}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        {!loader && (
          <Row>
            <Col
              md={6}
              sm={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="hero-text-wrapper">
                <p className="hero-headline my-3">
                  {/* A <span className="accent">REVOLUTIONARY</span> NEW PLATFORM
                  FOR TAMPER-PROOF DIGITAL DOCUMENTS
                  REVOLUTIONARY  */}

                  <span className="txt">The next generation of <span className="accent">digital document </span>authentication</span>
                </p>
                <div className="linear-line mb-4"></div>
                <p className="hero-content">
                DocTrust is a credible system powered by Ethereum blockchain to issue and verify digital documents.
                </p>
              </div>
            </Col>
            <Col
              md={6}
              sm={12}
              className="d-flex justify-content-center upload-box-for-anm"
            >
              <div className="text-center">
                <p className="text-muted text-center">Verify your doc here</p>
                <DragAndDrop setFileName={setFileName} onsubmit={onSubmit} />
                <button className="mt-4 linear-btn" onClick={()=>setModalShow2(true)}>
                  Click here for verification demo
                </button>
              </div>
            </Col>
          </Row>
        )}
        {loader && (
          <Row className="justify-content-sm-center loading-wrapper w-100">
            <Col md={6} sm={8} lg={4}>
                <div className="text-center w-100 loading-inner-wrapper m-0">
                    <img src={logo} alt="loading logo animation" className="img-fluid loading-logo" />
                    <div className="loading-progress-bar my-3">
                        <div></div>
                    </div>
                    <p className="mt-2">Verifying</p>
                </div>
            </Col>
          </Row>
            
        )}
      </Container>

      <div className="mt-5 py-5 features">
        <Container>
          <Row className="featureWrapper pb-5">
            <Col xs={12} className="d-flex justify-content-center my-5">
              <div className="feature-main-heading p-2">
                <p className="m-0" data-aos="fade-up" data-aos-duration="1500">
                  {/* An Authentic Digital World With Legidoc */}
                  Authenticate Digital document With DocTrust
                </p>
              </div>
            </Col>
            {featureContent.map((data, index) => {
              return (
                <FeatureContent
                  content={data.desc}
                  image={data.image}
                  title={data.title}
                  key={index}
                />
              );
            })}
          </Row>
        </Container>
      </div>

      <div className="keyPoints py-5">
        <Container>
          <Row className="my-5">
            {featureCardContent.map((data, index) => {
              return <FeatureCard content={data} key={index} index={index} />;
            })}
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Home;
